/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPlanChangeApprovalRequestApproveResponseData
 */
export interface PostPlanChangeApprovalRequestApproveResponseData {
    /**
     * プラン変更承認依頼の承認メールの送信に成功したか
     * @type {boolean}
     * @memberof PostPlanChangeApprovalRequestApproveResponseData
     */
    isSentSuccess: boolean;
    /**
     * プラン変更承認依頼の承認メールを送信したメールアドレス
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestApproveResponseData
     */
    sentMailAddress: string;
}

export function PostPlanChangeApprovalRequestApproveResponseDataFromJSON(json: any): PostPlanChangeApprovalRequestApproveResponseData {
    return PostPlanChangeApprovalRequestApproveResponseDataFromJSONTyped(json, false);
}

export function PostPlanChangeApprovalRequestApproveResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPlanChangeApprovalRequestApproveResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSentSuccess': json['is_sent_success'],
        'sentMailAddress': json['sent_mail_address'],
    };
}

export function PostPlanChangeApprovalRequestApproveResponseDataToJSON(value?: PostPlanChangeApprovalRequestApproveResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_sent_success': value.isSentSuccess,
        'sent_mail_address': value.sentMailAddress,
    };
}

